import FooterHero from '../../component/common/CTA'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'
import { Helmet } from 'react-helmet';
import Banner from '../../component/common/Banner';
import CirclePoints from '../../component/common/circlePoints';
import Reviews from '../../component/common/reviews';
import { FaArrowRight } from 'react-icons/fa6';
import ExpansionFrameworkSection from '../../component/common/ExpansionSection';

const serviceCards = [
  {
    title: "Startup Scouting & Curation",
    text: "Identifying top startups solving key industry challenges.",
    subtext: "",
    iconLink: "img/enterprise-help1.png"
  },
  {
    title: "Integration & Scaling",
    text: "Seamlessly adopting startup innovations into enterprise workflows.",
    subtext: "",
    iconLink: "img/enterprise-help2.png"
  },
  {
    title: "Pilot Programs & (PoCs)",
    text: "Validating startup solutions in real-world scenarios.",
    subtext: "",
    iconLink: "img/enterprise-help3.png"
  },
  {
    title: "Corporate Venture Engagement",
    text: "Helping enterprises invest in high-growth startups.",
    subtext: "",
    iconLink: "img/enterprise-help4.png"
  }
];

const statsDataHeading = {
  light: "Industries",
  bold: "We Work With:"
}

const statsData = [
  {
    text: "Healthcare & MedTech",
    img: "img/industry1.png"
  },
  {
    text: "FinTech & Banking",
    img: "img/industry2.png"
  },
  {
    text: "E-commerce & Retail",
    img: "img/industry3.png"
  },
  {
    text: "Manufacturing & Industry 4.0",
    img: "img/industry4.png"
  },
  {
    text: "Sustainability & CleanTech",
    img: "img/industry5.png"
  }
];

const worldMapImg = "img/why-enterprise.png";


const headerData = {
  title: "How We Help",
  highlightedText: "Enterprises innovate",
  description: "From idea to exit, together. When we partner with founders, we're all-in: combining expertise, empathy, embedded resources, and capital to build breakout companies.",
  imgLink: "img/help-enterprise.png"
};

const BANNER_CONTENT = [{ subHeading : 'Innovation doesn’t happen in Silos' , description : 'We help enterprises discover, validate, and integrate startup-led solutions that solve real business challenges.' , url : 'https://forms.gle/hRT1f96s5cWEg16U8' , linkText: 'Apply Now'}]

const INNOVATION_POINTS = [
  { img : 'img/innovation-1.png' , figCaption : 'Discover' , description : 'Define key business challenges'},
  {img : 'img/innovation-2.png' , figCaption : 'Match' , description : 'Source startup solutions'},
  {img : 'img/innovation-3.png' , figCaption : 'Pilot' , description : 'Structured low-risk execution'},
  {img : 'img/innovation-4.png' , figCaption : 'Scale' , description : 'Integration and ROI tracking'},
]

const HOW_IT_WORKS = [
  {img : 'img/innovation-1.png' , heading : 'Discover' , description : 'Identify high-impact problem areas' , content : 'We conduct an innovation discovery sprint with your teams to identify and prioritize core challenges across operations, customer experience, supply chain, etc.' , points : ['Cross-functional workshops' , 'Problem framing' , 'Innovation needs framework']},
  {img : 'img/innovation-2.png' , heading : 'Match' , description : 'Curate startup solutions from our network' , content : 'Our team identifies and curates the most relevant startup solutions globally that match your challenge and business context.' , points : ['Startup scouting' , 'Landscape analysis' , 'Shortlisting & CoE sessions']},
  {img : 'img/how-it-works-enterprise-3.png' , heading : 'Co-Create Pilot' , description : 'Rapid execution in live environments' , content : 'We design and run structured, low-risk pilot projects with startups — ensuring clarity on success metrics, cost, and timelines.' , points : ['Pilot design (timeline, scope, KPIs)' , 'Live execution support' , 'Performance tracking & reporting']},
  {img : 'img/how-it-works-enterprise-4.png' , heading : 'Scale & Integrate' , description : 'Turn pilot learnings into business impact' , content : 'We help you scale validated solutions across teams and geographies, supported by enterprise-grade onboarding, integrations, and procurement processes.' , points :[ 'Scaling playbooks' , 'Enterprise onboarding' , 'Stakeholder & change management' , 'Integration & procurement support']},
]

const caseStudiesData = [
  {
    image: "img/logos/dalmia.png",
    heading: {bold : "Dalmia Bharat " , light : '– Innovation Through Startup Matchmaking'},
    content : [
      {title : 'Challenge' , description : 'Their order-to-delivery cycle was 7+ days due to offline dealer ordering.'},
      {title : 'TurningIdeas Role' , description : 'We scouted and matched them with a mobile-first tech startup, facilitated pilot co-design, and helped launch mSuvidha, a custom dealer ordering app.'},
      {title : 'Outcome' , description : 'Dealer order time dropped to <24 hours, revenue throughput increased, and the app became a core part of their pan-India supply chain.'}
    ]
  },
  {
    image: "img/logos/ginesys.png",
    heading: {bold : "Ginesys  " , light : '– Retail SaaS GTM & Ecosystem Orchestration'},
    content : [
      {title : 'Challenge' , description : 'Ginesys was shifting from legacy POS to its new cloud product — but adoption by existing customers was slow.'},
      {title : 'TurningIdeas Role' , description : 'We helped articulate the cloud value proposition, designed the partner onboarding strategy, and created a multi-vendor API economy roadmap (EaseMyRetail).'},
      {title : 'Outcome' , description : 'Faster cloud migration among existing customers, and new cross-sell opportunities across fintech, loyalty, and ERP integrations.'}
    ]
  },
];

const EnterprisePage = () => {
  return (
    <div>
      <Helmet>
        <title>Corporate Innovation Studio | Startup Collaboration India</title>
        <meta name="description" content="TurningIdeas helps enterprises discover, validate, and integrate startup-led innovations to reduce costs, boost speed, and enable transformation." />
        <meta name="keywords" content="enterprise innovation India, startup collaboration India, pilot with startup, corporate venture studio" />
      </Helmet>
      
      <Banner content={BANNER_CONTENT} img='img/Banner/Enterprise.png' />

      <CirclePoints heading='Your India Journey in 5 Steps' points={INNOVATION_POINTS} className='grid min-[607px]:grid-cols-2 min-[847px]:grid-cols-4 gap-y-10' />

      <section className="container max-w-7xl mx-auto px-6 md:px-12">
        <HowWeHelp
          headerData={headerData}
          serviceCards={serviceCards}
          statsDataHeading={statsDataHeading}
          statsData={statsData}
          worldMapImg={worldMapImg}
        />
      </section>

      <ExpansionFrameworkSection HOW_IT_WORKS={HOW_IT_WORKS} heading='How It Works' subHeading='Enterprise Innovation Workflow' description='Enterprise innovation is hard — too many challenges, too little clarity. TurningIdeas makes it simple with a structured innovation engine built to help teams move faster, test viable startup solutions, and scale them for impact.' />

      <section className="py-6 md:py-12 bg-black">
        <div className="container max-w-7xl mx-auto px-6 md:px-12">
          <CaseStudySlider caseStudies={caseStudiesData} />
        </div>
      </section>

      <FooterHero
        heading="Want a Partner to Co-Build"
        paragraph="Whether you're a Startup, Investor or Enterprise, We help you Scale, Innovate and Succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default EnterprisePage;
